<template>
  <div class="col-field">
    <div v-for="(item, index) in items" :key="index" class="mb-10 form-radio form-radio-inline">
      <input :id="makeId(name, item[valueKey])" v-model="selected" :value="item[valueKey]" :name="name" type="radio" class="form-radio-input" :onclick="isReadonly()" :disabled="item[disabledKey]">
      <label class="form-radio-label dark-radio-label" :for="makeId(name, item[valueKey])">{{ item[labelKey] }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalRadio',
  props: {
    value: {
      type: [String, Number, Boolean],
      required: false,
      default: () => ({}),
    },
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    valueKey: {
      type: String,
      required: false,
      default: 'id',
    },
    labelKey: {
      type: String,
      required: false,
      default: 'label',
    },
    disabledKey: {
      type: String,
      required: false,
      default: 'disabled',
    },
    readonly: {
      type: Boolean,
      defalut: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        if (!this.readonly) {
          this.$emit('input', value);
        }
      },
    },
  },
  methods: {
    makeId(name, value) {
      return `${name}${value}`;
    },
    isReadonly() {
      if (this.readonly) {
        return 'return false';
      }
      return 'return true';
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-10 {
  margin-bottom: 10px;
}
.horizontal-radio {
  padding: 10px 0 10px 0;
  &>li {
    float: left;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  &>:first-child {
    margin-left: 0;
  }
}
</style>
